import { render, staticRenderFns } from "./EditAssignedServicesOfCompanyModal.vue?vue&type=template&id=c7beef54&"
import script from "./EditAssignedServicesOfCompanyModal.vue?vue&type=script&lang=ts&"
export * from "./EditAssignedServicesOfCompanyModal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports